import { FC } from "react";
import { Checkbox, CheckboxProps } from "@mantine/core";

// ----------------------------------------------------------------------------------------------

export type TCheckboxProps = CheckboxProps & {};

const TCheckbox: FC<TCheckboxProps> = (props) => {
  const { className, ...other } = props;

  return (
    <Checkbox
      radius={0}
      classNames={{
        icon: "w-3",
        body: "items-center",
        labelWrapper: "w-full",
        label:
          "w-fit cursor-pointer pl-4 text-base font-semibold text-gray-900 lg:text-sm",
        input:
          "cursor-pointer border-2 checked:border-primary-900 checked:bg-primary-900",
      }}
      className={className}
      {...other}
    />
  );
};

export default TCheckbox;
